export default "__VITE_ASSET__ce4a0b2a__"